export default {
  wikiApi: `https://en.wikipedia.org/w/api.php`,
  wikiSearchApiUrl: `https://en.wikipedia.org/w/rest.php/v1/search/title`,
  getViews:
    "https://wikimedia.org/api/rest_v1/metrics/pageviews/per-article/en.wikipedia.org/all-access/all-agents/{slug}/{period}/{from}/{to}",
  getRevisions:
    "https://api.wikimedia.org/core/v1/wikipedia/en/page/{slug}/history",
  editsHistoryUrl:
    "https://en.wikipedia.org/w/index.php?title={title}&action=history",
  // getRevision: 'https://traditional-isadora-lynart-47b83f18.koyeb.app/parse/wiki/{id}',
  apiUrl: "http://localhost:9000/parse/wiki/{id}",
  checkRedirect:
    "https://en.wikipedia.org/w/api.php?action=query&redirects&format=json&titles={title}",
  contributions:
    "https://en.wikipedia.org/wiki/Special:Contributions/{username}",
  api: "http://test.wikitrace247.com/api",
  // api: "http://localhost:9007/api",
  xToolUrl: "https://xtools.wmcloud.org/pageinfo/en.wikipedia.org",
};
